import { useState } from 'react';
import { Button, Typography } from '@la/ds-ui-components';
import { Activity } from '@la/types';
import { isGameActivity } from 'lib/utils/schedules/isGameActivity';
import {
  ProgramPermissions,
  TeamPermissions,
  UserSummary,
} from 'redux/services/types/singleActivity';
import ActivityAttendance from './ActivityAttendance/ActivityAttendance';
import ActivityCheckIn from './ActivityCheckIn/ActivityCheckIn';
import ActivityMatchup from './ActivityMatchup/ActivityMatchup';
import styles from './SingleActivityViewSidePanel.module.scss';

export default function SingleActivityViewSidePanel({
  activity,
  permissions,
  userSummaries,
}: {
  activity?: Activity;
  permissions?: ProgramPermissions;
  userSummaries: UserSummary[];
}) {
  const isGame = isGameActivity(activity?.type);

  const { viewRsvpResponses, viewRosters, teamPermissions, viewCheckIn } =
    permissions ?? {};

  const viewCheckinPermission = getEditCheckinPermission(teamPermissions);

  // Check if member is part of any teams for this activity
  const activityTeamIds = activity?.teams?.map((team) => team.teamId) || [];
  const memberHasTeamsForActivity =
    userSummaries[0]?.teamIds?.some((teamId) =>
      activityTeamIds.includes(teamId)
    ) || false;

  const [activeTab, setActiveTab] = useState('default');
  const tabPermissionsArray = [
    {
      canView: viewRsvpResponses && memberHasTeamsForActivity,
      value: 'attendance',
      display: 'Attendance',
    },
    {
      canView: isGame && viewRosters && memberHasTeamsForActivity,
      value: 'matchup',
      display: 'Matchup',
    },
    {
      canView:
        viewCheckIn && viewCheckinPermission && memberHasTeamsForActivity,
      value: 'checkin',
      display: 'Check in',
    },
  ];

  return (
    <div className={styles.sidePanelContainer}>
      <div className={styles.sidePanelTabsContainer}>
        {tabPermissionsArray.map(({ value, display, canView }) => (
          <div key={value} className={styles.sidePanelTabs}>
            {canView ? (
              <Button onClick={() => setActiveTab(value)} variant="text">
                <Typography variant="ui" size="medium" weight="bold">
                  {display}
                </Typography>
              </Button>
            ) : null}
          </div>
        ))}
      </div>

      {activeTab === 'attendance' && (
        <ActivityAttendance activity={activity} userSummaries={userSummaries} />
      )}
      {activeTab === 'matchup' && (
        <ActivityMatchup activity={activity} userSummaries={userSummaries} />
      )}
      {activeTab === 'checkin' && (
        <ActivityCheckIn activity={activity} userSummaries={userSummaries} />
      )}
    </div>
  );
}

const getEditCheckinPermission = (teamPermissions?: TeamPermissions[]) => {
  if (teamPermissions && teamPermissions.length > 0) {
    const editCheckIn = teamPermissions.filter((obj) => obj.editCheckIn);
    return !!editCheckIn.length;
  }
};
